import type { WithdrawalNoteStatus } from '@/lib/api/scenting-lot-api'
import { Badge } from '@/components/ui/badge'
import { m } from '@/lib/paraglide/messages'

// open: còn hàng (đang mở) → tông "đang chờ". closed: đã rút cạn → tông "duyệt".
// cancelled: người tạo huỷ.
const STATUS_CLASS: Record<WithdrawalNoteStatus, string> = {
    open: 'bg-status-pending text-status-pending-foreground',
    closed: 'bg-status-approved text-status-approved-foreground',
    cancelled: 'bg-status-cancelled text-status-cancelled-foreground',
}

function label(status: WithdrawalNoteStatus): string {
    switch (status) {
        case 'open':
            return m.scl_withdrawal_status_open()
        case 'closed':
            return m.scl_withdrawal_status_closed()
        case 'cancelled':
            return m.scl_withdrawal_status_cancelled()
    }
}

export function WithdrawalNoteStatusBadge({
    status,
    className,
}: {
    status: WithdrawalNoteStatus
    className?: string
}) {
    return (
        <Badge className={`${STATUS_CLASS[status]} ${className ?? ''}`}>
            {label(status)}
        </Badge>
    )
}
